module.exports = __webpack_public_path__ + "img/94e840f.jpg";